import AccessLinkCreator from './AccessLinkCreator.js';
import AccessRouteCreator from './AccessRouteCreator.js';
export default (molten, cxt) => {
  const {
    relationship
  } = cxt;
  const userMgmtLinkActionId = `link.${relationship.path}.Access`;
  const userMgmtRouteId = `route.${relationship.path}.Access`;
  molten.addPlugin('Action', AccessLinkCreator({
    id: userMgmtLinkActionId,
    relationship
  }));
  molten.addPlugin('Route', AccessRouteCreator({
    id: userMgmtRouteId,
    relationship
  }));
};